import "./ServicePages.css";
import React, { useState } from "react";

const screenshots = require.context(
  "../assets/BooksCoverPage/",
  false,
  /\.(png|jpe?g|svg)$/
).keys().map(
  require.context(
    "../assets/BooksCoverPage/",
    false,
    /\.(png|jpe?g|svg)$/
  )
);

const TypesettingLayout = () => {
    const [selectedImage, setSelectedImage] = useState(null);
  
    const brandingImages = [
      ...screenshots
    ];
  return (
    <section className="service-page">
      <div className="service-hero">
        <h1>Typesetting & Layout Design</h1>
        <p>
          Professional page layout and formatting for educational and publishing
          needs.
        </p>
      </div>

      <div className="service-content">        
        {/* IMAGE GRID */}
        <div className="image-gallery">
          {brandingImages.map((img, index) => (
            <div
              className="image-card"
              key={index}
              onClick={() => setSelectedImage(img)}
            >
              <div className="image-wrapper">
                <img src={img} alt={`Branding sample ${index + 1}`} />
              </div>
              <div className="image-overlay">
                <span>View</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* MODAL */}
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Selected branding work" />
          <span className="close-btn">&times;</span>
        </div>
      )}
    </section>
  );
};

export default TypesettingLayout;
